import { Container, DescWhatIs, DescWhatIsnt } from './styles';

export const Descriptions = (props: {
  whatIs: string;
  whatIsnt: string;
}): JSX.Element => {
  const { whatIs, whatIsnt } = props;

  return (
    <Container>
      <DescWhatIs>
        <div className="title">O que cobre?</div>
        {whatIs.split('\n').map((paragraph: string) => (
          <p key={paragraph}>{paragraph}</p>
        ))}
      </DescWhatIs>
      <DescWhatIsnt>
        <div className="title">O que não cobre?</div>
        {whatIsnt.split('\n').map((paragraph: string) => (
          <p key={paragraph}>{paragraph}</p>
        ))}
      </DescWhatIsnt>
    </Container>
  );
};
